module.exports = __webpack_public_path__ + "img/dryva-screen-10.557358e6.png";